import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const TestimonialItem = ({
    name,
    position,
    company,
    companyLink,
    rating = 5,
    text,
    avatar,
    image,
    buttonText,
    buttonLink = "#",
    variant = "photo" // "photo" or "image"
}) => {
    const { t } = useLanguage();
    const defaultButtonText = buttonText || t('common.buttons.view_project');

    // Verificar si tiene imagen real (no dummy)
    const hasRealImage = image &&
        !image.includes('dummyimage.com') &&
        image.trim() !== '';

    // Verificar si tiene avatar real (no dummy)
    const hasRealAvatar = avatar &&
        !avatar.includes('dummyimage.com') &&
        avatar.trim() !== '';

    // Verificar si tiene enlace real (no "#")
    const hasRealLink = buttonLink &&
        buttonLink !== "#" &&
        buttonLink.trim() !== '';
    const renderStars = (rating) => {
        return Array.from({ length: 5 }, (_, index) => (
            <i key={index} className={`ph-fill ph-star ${index < rating ? '' : 'opacity-50'}`}></i>
        ));
    };

    if (variant === "image") {
        return (
            <div className="swiper-slide mxd-fullwidth-slide no-blur">
                <div className="mxd-testimonials-image">
                    <div className="container-fluid p-0 fullheight-l">
                        <div className="row g-0 d-flex align-items-stretch fullheight-l">
                            <div className="col-12 col-xl-7 mxd-testimonials-image__content mxd-grid-item no-margin">
                                <div className="mxd-testimonials-image__author" data-swiper-parallax-x="-50" data-swiper-parallax-opacity="0">
                                    {hasRealAvatar && (
                                        <div className="mxd-testimonials-image__avatar">
                                            <img src={avatar} alt={t('common.alt_texts.review_author')} />
                                        </div>
                                    )}
                                    <div className="mxd-testimonials-image__info">
                                        <h5 className="mxd-testimonials-image__name">{name}</h5>
                                        <p className="mxd-testimonials-image__position t-small">
                                            {position} {company && (
                                                <>
                                                    en <a className="link-small-underline" href={companyLink || "#"}>{company}</a>
                                                </>
                                            )}
                                        </p>
                                        <div className="mxd-testimonials-image__rating">
                                            {renderStars(rating)}
                                        </div>
                                    </div>
                                </div>
                                <div className="mxd-testimonials-image__text" data-swiper-parallax-x="-100" data-swiper-parallax-opacity="0">
                                    <p className="t-large">{text}</p>
                                    {hasRealLink && (
                                        <a className="btn btn-anim btn-outline-primary btn-small slide-right-up" href={buttonLink}>
                                            <span className="btn-caption">{defaultButtonText}</span>
                                            <i className="ph ph-arrow-up-right"></i>
                                        </a>
                                    )}
                                </div>
                            </div>
                            {hasRealImage && (
                                <div className="col-12 col-xl-5 mxd-testimonials-image__img mxd-grid-item no-margin" data-swiper-parallax-x="-50" data-swiper-parallax-opacity="0">
                                    <img src={image} alt={t('common.alt_texts.testimonial_image')} />
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Default "photo" variant
    return (
        <div className="swiper-slide mxd-fullwidth-slide">
            <div className="mxd-testimonials-photo">
                <div className="container-fluid p-0 fullheight-l">
                    <div className="row g-0 d-flex align-items-stretch fullheight-l">
                        <div className="col-12 col-lg-6 mxd-testimonials-photo__content mxd-grid-item no-margin">
                            <div className="mxd-testimonials-photo__author" data-swiper-parallax-x="-250" data-swiper-parallax-opacity="0">
                                {hasRealAvatar && (
                                    <div className="mxd-testimonials-photo__avatar">
                                        <img src={avatar} alt={t('common.alt_texts.review_author')} />
                                    </div>
                                )}
                                <div className="mxd-testimonials-photo__info">
                                    <h5 className="mxd-testimonials-photo__name">{name}</h5>
                                    <p className="mxd-testimonials-photo__position t-small">
                                        {position} {company && (
                                            <>
                                                en <a className="link-small-underline" href={companyLink || "#"}>{company}</a>
                                            </>
                                        )}
                                    </p>
                                    <div className="mxd-testimonials-photo__rating">
                                        {renderStars(rating)}
                                    </div>
                                </div>
                            </div>
                            <div className="mxd-testimonials-photo__text" data-swiper-parallax-x="-300" data-swiper-parallax-opacity="0">
                                <p className="t-large">{text}</p>
                                {hasRealLink && (
                                    <a className="btn btn-anim btn-outline-primary btn-small slide-right-up" href={buttonLink}>
                                        <span className="btn-caption">{defaultButtonText}</span>
                                        <i className="ph ph-arrow-up-right"></i>
                                    </a>
                                )}
                            </div>
                        </div>
                        {hasRealImage && (
                            <div className="col-12 col-lg-6 mxd-testimonials-photo__image mxd-grid-item no-margin fullheight-l" data-swiper-parallax-x="-450" data-swiper-parallax-opacity="0">
                                <div className="mxd-testimonials-photo__image-inner radius-l fullheight-l">
                                    <img src={image} alt={t('common.alt_texts.testimonial_image')} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TestimonialItem;
